import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import Label from "../../../components/Label";
import CustomDropDown from "../../../components/CutomDropDown";
import TextInput from "../../../components/TextInputs";
import globalStyle from "../../../globalStyle";
import { TimePicker } from "@mui/x-date-pickers";
import GlobalButton from "../../../components/CustomButton";

const allClasses = ["Class 1", "Class 2", "Class 3", "Class 4"];
const Sections = ["Section A", "Section B", "Section c"];
const Subjects = ["Math", "physic", "Biology"];

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));
let paramsData = {};

const AddEditTimeTable = forwardRef(({}, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      paramsData = params;
      setOpen(true);
    },
    closeDialog() {
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <IconButton
        sx={{ position: "absolute", top: "5px", right: "5px" }}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
      <DialogTitle
        variant="h1"
        fontWeight={600}
        fontSize={"1.325rem"}
        fontFamily={"inter"}
        sx={{ m: 0, p: 2 }}
        id="customized-dialog-title"
      >
        {paramsData?.type === "add"
          ? "Create New Time Table"
          : "Edit Time Table"}
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Label labelText="Select Class" required />
            <CustomDropDown>
              {allClasses.map((val, index) => {
                return (
                  <MenuItem key={index} value={val}>
                    {val}
                  </MenuItem>
                );
              })}
            </CustomDropDown>
          </Grid>
          <Grid item xs={6}>
            <Label labelText="Select Section" required />
            <CustomDropDown>
              {Sections.map((val, index) => {
                return (
                  <MenuItem key={index} value={val}>
                    {val}
                  </MenuItem>
                );
              })}
            </CustomDropDown>
          </Grid>
          <Grid item xs={6}>
            <Label labelText="Select Subject" required />
            <CustomDropDown>
              {Subjects.map((val, index) => {
                return (
                  <MenuItem key={index} value={val}>
                    {val}
                  </MenuItem>
                );
              })}
            </CustomDropDown>
          </Grid>
          <Grid item xs={6}>
            <Label labelText="Teacher" required />
            <TextInput styleProps={globalStyle.textField} />
          </Grid>
        </Grid>
        <Typography variant="h6" my={2}>
          Time Structure
        </Typography>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Label labelText="From" />
            <TimePicker
              sx={{
                "&.MuiTextField-root": { width: "100% !important" },
                ...globalStyle.textField,
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <Label labelText="To" />
            <TimePicker
              sx={{
                "&.MuiTextField-root": { width: "100% !important" },
                ...globalStyle.textField,
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <GlobalButton
          variant={"custom_outlined"}
          btnText={"Close"}
          handleClickBtn={handleClose}
          styleProps={{ width: 100, height: 40 }}
        />
        <GlobalButton
          variant={"contained"}
          btnText={paramsData?.type === "add" ? "Created":"Update"}
          handleClickBtn={handleClose}
          styleProps={{ width: 100, height: 40 }}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default AddEditTimeTable;
